import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// The type-scale roles in tailwind.config.ts. Unregistered, tailwind-merge would read
// `text-body` as a colour and drop it next to `text-muted-foreground`.
const TYPE_SCALE_ROLES = [
  "page-title",
  "section-title",
  "card-title",
  "lead",
  "body",
  "caption",
  "label",
  "metric",
  "kpi",
] as const

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [...TYPE_SCALE_ROLES] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
